import { ErrorHandler, Injectable, inject } from '@angular/core';

import { environment } from '../../../environments/environment';
import { DatadogService } from './datadog.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly datadog = inject(DatadogService);

  handleError(error: unknown): void {
    if (!environment.production) {
      console.error('[GlobalErrorHandler]', error);
      return;
    }

    // Production: send error to Datadog RUM. Errors raised before the SDK
    // finishes loading are buffered by the boundary, not dropped.
    this.datadog.addError(error instanceof Error ? error : new Error(String(error)));
  }
}
